document.addEventListener('DOMContentLoaded', async () => {

    function updatePriceSavingForContainers(rrp, price) {
        const priceSelectors = [
            ".summary-side-panel .price .price__container",
            ".price-display .price .price__container",
            ".price-mob-container .price .price__container"
        ];
        for (const selector of priceSelectors) {
            const priceContainer = document.querySelector(selector);
            if (!priceContainer) {
                continue;
            }

            // Get DOM elements and price values
            const priceSaving = priceContainer.querySelector('span.price-saving');
            const rrpPrice = priceContainer.querySelector('span.rrp');
            const rrpPriceLabel = priceContainer.querySelector('span.rrp-label');
            const rrpContainer = priceContainer.querySelector('.rrp-container');

            // Update RRP display if available
            if (rrp && rrp > 0 && rrpPrice) {
                rrpPrice.innerHTML = `&pound; ${(rrp / 100).toFixed(2)}`;
                if (rrpPriceLabel) rrpPriceLabel.innerText = 'New RRP';

                // Show or hide savings based on price comparison
                if (priceSaving) {
                    const savingsPercentage = Math.round((rrp - price) / rrp * 100);
                    const shouldShowSavings = rrp > price && savingsPercentage > 0;

                    if (shouldShowSavings) {
                        priceSaving.innerText = `-${savingsPercentage}%`;
                    }

                    rrpContainer.classList.toggle('hidden', !shouldShowSavings);
                    priceSaving.classList.toggle('hidden', !shouldShowSavings);
                    rrpPrice.classList.toggle('rrp-price-line-through', shouldShowSavings);
                }
            }
        }
    }

    document.addEventListener("variant:updated", (event) => {
        if (!event.detail || !event.detail.variantId || !window.originalVariantsData) {
            return;
        }
        const variant = getVariantById(window.originalVariantsData, event.detail.variantId);
        if (!variant) {
            return;
        }
        updatePriceSavingForContainers(variant.rrpPrice, variant.price);
    });

    document.addEventListener("update-saving", (event) => {
        if (!event.detail) {
            return;
        }
        const price = Number.parseInt(event.detail.price, 10);
        const rrp = Number.parseInt(event.detail.rrpPrice, 10);
        updatePriceSavingForContainers(rrp, price);
    });
});
